
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 125"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38.68 67.62H26.06v-8.39h-8.4V46.6h8.4v-8.4h12.62v8.4h8.4v12.63h-8.4zm-9.22-3.4h5.82v-8.4h8.4V50h-8.4v-8.4h-5.82V50h-8.4v5.82h8.4z"}}),_c('path',{attrs:{"d":"M89.53 21.21H10.44a4.87 4.87 0 00-4.86 4.86v53.08A4.87 4.87 0 0010.44 84h79.09a4.87 4.87 0 004.86-4.86V26.07a4.87 4.87 0 00-4.86-4.86zM9 79.15V26.07a1.46 1.46 0 011.46-1.46h42.26v56H10.44A1.46 1.46 0 019 79.15zm82 0a1.46 1.46 0 01-1.46 1.46H56.12v-56h33.41A1.46 1.46 0 0191 26.07z"}}),_c('path',{attrs:{"d":"M61.55 38.22h21.91v3.4H61.55zM61.55 45.8h16.97v3.4H61.55zM61.55 53.32h16.97v3.4H61.55z"}})])
          )
        }
      }
    